import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing8,
  spacing16,
  spacing20,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import {
  font14,
  fontSize14,
  LinkProps,
  LinkStyled,
  PStyled,
} from 'approot/shared/styles/typography.style';
import {
  grey1,
  grey4,
  grey7,
  grey8,
} from 'approot/shared/styles/colours.style';
import ErrorMessageStyled from 'approot/shared/error-message/error-message.style';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import { OauthButtonStyled } from './signin-oauth/signin-oauth.style';

export const SignInContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SignInButton = styled.div`
  margin-bottom: ${rem(spacing8)};
  button {
    width: 100%;
  }
`;

type SignInSsoButtonsProps = {
  marginBottom?: number;
};

export const SignInSsoButtons = styled.div<SignInSsoButtonsProps>`
  display: flex;
  flex-direction: column;
  gap: ${rem(spacing16)};
  margin-bottom: ${({ marginBottom = spacing20 }) => rem(marginBottom)};
  padding: 0;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

type SignInLinkContainerProps = {
  marginBottom?: number;
};

export const SignInLinkContainer = styled.div<SignInLinkContainerProps>`
  ${font14}
  color: ${grey8};
  margin-bottom: ${({ marginBottom = 0 }) => `${rem(marginBottom)}`};
  text-align: center;
`;

export const SignInLink = styled(LinkStyled)`
  font-size: ${rem(fontSize14)};
`;

type SignInOrProps = {
  $marginBottom?: number;
  $marginTop?: number;
};

export const SignInOr = styled.div<SignInOrProps>`
  ${font14}
  color: ${grey8};
  position: relative;
  margin-bottom: ${({ $marginBottom = spacing16 }) => rem($marginBottom)};
  margin-top: ${({ $marginTop = 0 }) => rem($marginTop)};
  text-align: center;

  span {
    background-color: ${grey1};
    padding: 0 ${rem(spacing16)};
    position: relative;
    z-index: 1;
  }

  &:after {
    content: '';
    background-color: ${grey4};
    position: absolute;
    height: 1px;
    left: 0;
    top: ${rem(11)};
    width: 100%;
  }
`;

export const SignInError = styled(ErrorMessageStyled).attrs({
  marginTop: 0,
  marginBottom: spacing24,
  tabIndex: -1,
})``;

export const SignInTermsText = styled(PStyled).attrs({
  marginBottom: spacing16,
})`
  ${font14}
`;

export const SignInTermsLink = styled(LinkStyled).attrs<LinkProps>({
  $fontWeight: 'normal',
})`
  font-size: ${rem(fontSize14)};
  color: ${grey7};
  text-decoration: underline;
`;

export const SignInFullWidthButtons = styled.div`
  width: 100%;

  ${OauthButtonStyled} {
    width: 100%;
    margin-bottom: ${rem(spacing16)};
  }

  ${SecondaryButton} {
    width: 100%;
    margin-bottom: ${rem(spacing8)};
  }
`;
